import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

// BonBoZ: chỉ admin — màu nhận diện trang là cấu hình chung cả đội, không phải
// tuỳ chọn cá nhân. Service CRM trả 403 cho người không phải administrator, ở
// đây giấu luôn lối vào để không ai bấm rồi mới biết mình không có quyền.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/page-appearance'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'bonboz_page_appearance_index',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
